var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"justify":"space-around"}},[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('NewsList')],1),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('CreateNew')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }